module.exports = function getResource(label) {
    let resources = {
        selectAShade: 'Choisissez une teinte',
        next: 'Suivant'
    };
    return resources[label];
};
